<sh-progress-label [type]="cell.labelType" [percentage]="cell.percentage">{{cell.value}}</sh-progress-label>
